import React from 'react'

function RedCross() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11">
      <g fill="#fe5f55" data-name="Group 56998">
        <path d="M7 0l7 7h-2.67L7 2.724 2.722 7H0z" data-name="Subtraction 199" transform="rotate(180 7 3.5)"></path>
        <path d="M7 7l7-7h-2.67L7 4.276 2.722 0H0z" data-name="Subtraction 200" transform="rotate(180 7 5.5)"></path>
      </g>
    </svg>
  )
}

export default RedCross
